/**
 * @param input {HTMLInputElement}
 * @return {void}
 */
module.exports = function uncheckInput(input) {
    input.checked = false;
}
